"use strict";

var _regeneratorRuntime = require("/codebuild/output/src400645628/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _lodash = _interopRequireDefault(require("lodash.memoize"));

var _commonReact = require("@devsta/common-react");

var _uiKit = require("@devsta/ui-kit");

var _utils = require("../../../../../common/utils");

var _hasFavouriteUpdated = _interopRequireDefault(require("../utils/hasFavouriteUpdated"));

var _PostListItem = _interopRequireDefault(require("../../../../../common/components/PostListItem"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var FILTERS = {
  order: [{
    label: 'Most Recent',
    value: 'DESC'
  }, {
    label: 'Oldest',
    value: 'ASC'
  }]
};

var withPostList = function withPostList(PostListComponent) {
  var PostListWrapper = /*#__PURE__*/function (_Component) {
    _inherits(PostListWrapper, _Component);

    function PostListWrapper() {
      var _this;

      _classCallCheck(this, PostListWrapper);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(PostListWrapper).call(this));

      _defineProperty(_assertThisInitialized(_this), "openViewPostModalAction", (0, _lodash.default)(function (post) {
        return function () {
          var openViewPostModal = _this.props.openViewPostModal;
          return openViewPostModal(post);
        };
      }));

      _defineProperty(_assertThisInitialized(_this), "loadInspirations", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this$props, getInspirations, filters, fetchAssets, _this$state, posts, listFilters, _ref2, data, error;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$props = _this.props, getInspirations = _this$props.getInspirations, filters = _this$props.filters, fetchAssets = _this$props.fetchAssets;
                _this$state = _this.state, posts = _this$state.posts, listFilters = _this$state.listFilters;

                _this.setState({
                  loading: true
                });

                _context.next = 5;
                return getInspirations(_objectSpread({
                  status: 'PUBLISHED',
                  sortBy: 'updatedAt',
                  limit: 16
                }, filters, {}, listFilters, {
                  isPublic: true
                }));

              case 5:
                _ref2 = _context.sent;
                data = _ref2.data;
                error = _ref2.error;
                fetchAssets(data && data.getInspirations);

                _this.setState({
                  loading: false,
                  posts: error ? posts : data.getInspirations,
                  error: error
                });

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })));

      _defineProperty(_assertThisInitialized(_this), "handleToggleFavourite", function (inspirationId) {
        return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
          var _this$props2, toggleInspirationFavourite, onInspirationFavourited, originalPosts, postIndex, originalPost, updatedPost;

          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _this$props2 = _this.props, toggleInspirationFavourite = _this$props2.toggleInspirationFavourite, onInspirationFavourited = _this$props2.onInspirationFavourited;
                  originalPosts = _this.state.posts;
                  postIndex = originalPosts.findIndex(function (post) {
                    return post.inspirationId === inspirationId;
                  });

                  if (!(postIndex <= -1)) {
                    _context2.next = 5;
                    break;
                  }

                  return _context2.abrupt("return");

                case 5:
                  originalPost = originalPosts[postIndex];
                  updatedPost = _objectSpread({}, originalPost, {
                    isFavourited: !originalPost.isFavourited
                  });

                  _this.setState({
                    posts: [].concat(_toConsumableArray(originalPosts.slice(0, postIndex)), [updatedPost], _toConsumableArray(originalPosts.slice(postIndex + 1)))
                  });

                  _context2.prev = 8;
                  _context2.next = 11;
                  return toggleInspirationFavourite({
                    inspirationId: inspirationId
                  });

                case 11:
                  onInspirationFavourited(updatedPost);
                  _context2.next = 17;
                  break;

                case 14:
                  _context2.prev = 14;
                  _context2.t0 = _context2["catch"](8);

                  _this.setState({
                    posts: originalPosts
                  });

                case 17:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, null, [[8, 14]]);
        }));
      });

      _defineProperty(_assertThisInitialized(_this), "renderCardItem", function (post) {
        var openReportModal = _this.props.openReportModal;
        var inspirationId = post.inspirationId,
            assetId = post.assetId,
            thumbnailUrl = post.thumbnailUrl;

        var cover = _react.default.createElement(_commonReact.AssetPreview, (0, _utils.buildAssetPreviewProps)({
          assetId: assetId,
          thumbnailUrl: thumbnailUrl
        }));

        return _react.default.createElement(_uiKit.List.CardItem, {
          className: "search-posts-list__card",
          key: inspirationId,
          customCoverImage: assetId || thumbnailUrl ? cover : void 0,
          coverImageProps: {
            defaultImageIcon: 'guide',
            defaultIconSize: 40
          },
          onClick: _this.openViewPostModalAction(post)
        }, _react.default.createElement(_PostListItem.default, {
          key: inspirationId,
          post: post,
          onToggleFavourite: _this.handleToggleFavourite(inspirationId),
          onReportOpen: openReportModal(inspirationId)
        }));
      });

      _defineProperty(_assertThisInitialized(_this), "onFiltersChange", function (_ref4) {
        var filters = _ref4.filters;

        _this.setState({
          listFilters: filters
        }, _this.loadInspirations);
      });

      _this.state = {
        listFilters: {},
        posts: [],
        loading: false,
        error: false
      };
      return _this;
    }

    _createClass(PostListWrapper, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.loadInspirations();
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        var _this$props3 = this.props,
            filters = _this$props3.filters,
            selectedInspirationOrgId = _this$props3.selectedInspirationOrgId,
            latestFavouriteUpdate = _this$props3.latestFavouriteUpdate;
        var posts = this.state.posts;
        var favouriteUpdated = (0, _hasFavouriteUpdated.default)(latestFavouriteUpdate, prevProps.latestFavouriteUpdate, posts);

        if (filters !== prevProps.filters || selectedInspirationOrgId !== prevProps.selectedInspirationOrgId || favouriteUpdated) {
          this.loadInspirations();
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this$state2 = this.state,
            posts = _this$state2.posts,
            error = _this$state2.error,
            loading = _this$state2.loading;
        return _react.default.createElement(PostListComponent, _extends({}, this.props, {
          handleToggleFavourite: this.handleToggleFavourite,
          renderCardItem: this.renderCardItem,
          onFiltersChange: this.onFiltersChange,
          loadInspirations: this.loadInspirations,
          posts: posts,
          filterOptions: FILTERS,
          error: error,
          loading: loading
        }));
      }
    }]);

    return PostListWrapper;
  }(_react.Component);

  return PostListWrapper;
};

var _default = withPostList;
exports.default = _default;